var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('body',{attrs:{"id":"app"}},[_c('HeaderCollapsible',{attrs:{"id":"header","links":_vm.routes,"account":_vm.isAccountVisible}}),_c('router-view'),_c('FooterFixed',{attrs:{"id":"footer"}}),_c('ToastNotification')],1)}
var staticRenderFns = []

export { render, staticRenderFns }